import React, { useState, useEffect } from "react";
import { MainLayoutAdmin } from "../../../layout/MainLayoutAdmin";
import { useNavigate, useParams } from "react-router-dom";
import {HOST} from '../../../config';

function ExamQuestCreate() {
  const { examId } = useParams();
  const [name, setName] = useState();
  const [traloi, setTraloi] = useState({});
  const [questionText, setQuestionText] = useState();
  const [questionImage, setQuestionImage] = useState();
  const [disableBtn, setDisableBtn] = useState(false);

  function handleChange(event) {
    const name = event.target.name;
    const type = event.target.type;
    const copy = JSON.parse(JSON.stringify(traloi));
    if (!copy[name]) {
      copy[name] = {};
    }
    if (type === "text") {
      copy[name]["answerText"] = event.target.value;
    } else {
      copy[name]["isCorrect"] = event.target.checked;
    }
    setTraloi(copy);
  }

  const navigate = useNavigate();

  function handleSave() {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/admin/login");
    }

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    const listTraLoi = Object.values(traloi);

    const raw = JSON.stringify({
      name,
      questionText,
      questionImage,
      answer: listTraLoi,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    setDisableBtn(true);

    fetch(`${HOST}/exam/admin/${examId}/question`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setDisableBtn(false);
        if (result === "") {
          alert("Tạo thành công");
          navigate(`/admin/exam/${examId}`);
        } else {
          alert("Tạo không thành công");
        }
        console.log(result);
      })
      .catch((error) => console.log("error", error));
  }
  console.log("RE RENDER", traloi);

  return (
    <MainLayoutAdmin>
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="align-middle inline-block min-w-full">
            <div className="shadow overflow-hidden p-2">
              <div className="mb-6">
                <label className="block mb-2 text-sm font-medium text-gray-900">
                  Câu hỏi số
                </label>
                <input
                  onChange={(e) => setName(e.target.value)}
                  type="number"
                  className="form-control
                  block
                  w-full
                  px-3
                  py-1.5
                  text-base
                  font-normal
                  text-gray-700
                  bg-white bg-clip-padding
                  border border-solid border-gray-300
                  rounded
                  transition
                  ease-in-out
                  m-0
                  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>

              <div className="mb-6">
                <label className="block mb-2 text-sm font-medium text-gray-900">
                  Nội dung câu hỏi
                </label>
                <input
                  onChange={(e) => setQuestionText(e.target.value)}
                  type="text"
                  className="form-control
                  block
                  w-full
                  px-3
                  py-1.5
                  text-base
                  font-normal
                  text-gray-700
                  bg-white bg-clip-padding
                  border border-solid border-gray-300
                  rounded
                  transition
                  ease-in-out
                  m-0
                  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>

              <div className="mb-6">
                <label className="block mb-2 text-sm font-medium text-gray-900">
                  Ảnh câu hỏi
                </label>
                <input
                  onChange={(e) => setQuestionImage(e.target.value)}
                  type="text"
                  className="form-control
                  block
                  w-full
                  px-3
                  py-1.5
                  text-base
                  font-normal
                  text-gray-700
                  bg-white bg-clip-padding
                  border border-solid border-gray-300
                  rounded
                  transition
                  ease-in-out
                  m-0
                  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>

              <div className="mb-6">
                <table className="table-fixed min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-100">
                    <tr>
                      <th
                        scope="col"
                        className="p-4 text-left text-xs font-medium text-gray-500"
                      >
                        Đáp án đúng
                      </th>
                      <th
                        scope="col"
                        className="p-4 text-left text-xs font-medium text-gray-500"
                      >
                        Nội dung trả lời
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    <tr className="hover:bg-gray-100">
                      <td className="p-4 whitespace-nowrap text-base font-medium text-gray-900">
                        <input
                          onChange={handleChange}
                          name="traloi1"
                          type="checkbox"
                          className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                      </td>
                      <td className="p-4 whitespace-nowrap text-base font-medium text-gray-900">
                        <input
                          onChange={handleChange}
                          name="traloi1"
                          type="text"
                          id="website-admin"
                          className="form-control
                          block
                          w-full
                          px-3
                          py-1.5
                          text-base
                          font-normal
                          text-gray-700
                          bg-white bg-clip-padding
                          border border-solid border-gray-300
                          rounded
                          transition
                          ease-in-out
                          m-0
                          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                          
                        />
                      </td>
                    </tr>

                    <tr className="hover:bg-gray-100">
                      <td className="p-4 whitespace-nowrap text-base font-medium text-gray-900">
                        <input
                          onChange={handleChange}
                          name="traloi2"
                          type="checkbox"
                          className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                      </td>
                      <td className="p-4 whitespace-nowrap text-base font-medium text-gray-900">
                        <input
                          onChange={handleChange}
                          name="traloi2"
                          type="text"
                          id="website-admin"
                          className="form-control
                          block
                          w-full
                          px-3
                          py-1.5
                          text-base
                          font-normal
                          text-gray-700
                          bg-white bg-clip-padding
                          border border-solid border-gray-300
                          rounded
                          transition
                          ease-in-out
                          m-0
                          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        />
                      </td>
                    </tr>

                    <tr className="hover:bg-gray-100">
                      <td className="p-4 whitespace-nowrap text-base font-medium text-gray-900">
                        <input
                          onChange={handleChange}
                          name="traloi3"
                          type="checkbox"
                          className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                      </td>
                      <td className="p-4 whitespace-nowrap text-base font-medium text-gray-900">
                        <input
                          onChange={handleChange}
                          name="traloi3"
                          type="text"
                          id="website-admin"
                          className="form-control
                          block
                          w-full
                          px-3
                          py-1.5
                          text-base
                          font-normal
                          text-gray-700
                          bg-white bg-clip-padding
                          border border-solid border-gray-300
                          rounded
                          transition
                          ease-in-out
                          m-0
                          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        />
                      </td>
                    </tr>

                    <tr className="hover:bg-gray-100">
                      <td className="p-4 whitespace-nowrap text-base font-medium text-gray-900">
                        <input
                          onChange={handleChange}
                          name="traloi4"
                          type="checkbox"
                          className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                      </td>
                      <td className="p-4 whitespace-nowrap text-base font-medium text-gray-900">
                        <input
                          onChange={handleChange}
                          name="traloi4"
                          type="text"
                          id="website-admin"
                          className="form-control
                          block
                          w-full
                          px-3
                          py-1.5
                          text-base
                          font-normal
                          text-gray-700
                          bg-white bg-clip-padding
                          border border-solid border-gray-300
                          rounded
                          transition
                          ease-in-out
                          m-0
                          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <button
                disabled={disableBtn}
                onClick={handleSave}
                type="submit"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Tạo câu hỏi
              </button>
            </div>
          </div>
        </div>
      </div>
    </MainLayoutAdmin>
  );
}

export default ExamQuestCreate;
